export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.2.11-1611.14',
  commitId: '953b7aa75688e42049dc87ecde580fd3f48d7689',
  commitTime: '2026-02-11T16:11:14.000Z',
});
